var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKroneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Ebene_3",
    x: "0px",
    y: "0px",
    viewBox: "0 0 507 79.8",
    style: {
      enableBackground: "new 0 0 507 79.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0064A3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "197.9,15.4 167.2,15.4 147.1,42.1 146.8,42.1 152.1,15.4 123.6,15.4 111.3,77.5 139.8,77.5    145.3,49.6 145.5,49.6 156.8,77.5 188.4,77.5 172.5,44.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,15.4h-43.4l-12.3,62.1h28.5l4.4-22.1h3.4c4.7,0,6.3,1.2,6.2,4.3c0,5.3-0.7,13.2,0.1,17.8h28.5   c-1.5-9.4,0.5-18.2-0.1-23.5c-0.5-4.7-3.8-7.4-10.8-7.9l0-0.2c11.5-2.2,16.1-7.7,17.5-14.8C273.2,19.4,264.7,15.4,249,15.4z    M242.3,35c-0.9,4.6-5.4,6.3-11,6.3h-2.4l2.4-11.8h2.6C239.6,29.5,243.1,30.4,242.3,35z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "416.2,15.4 408.8,55.6 408.6,55.6 400.5,15.4 365.6,15.4 353.3,77.5 376.9,77.5 384.4,37 384.6,37    392.6,77.5 427.5,77.5 439.8,15.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "503.9,31.6 507,15.4 451.2,15.4 438.9,77.5 495.6,77.5 498.8,61.3 470,61.3 471.3,54.4 497.2,54.4    500.4,38.2 474.5,38.2 475.9,31.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "54,57.3 61.7,0 48.5,12.7 35.3,0 43,57.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,64.3l6.6-6.4c-6.2-4.6-10.3-11-9.7-18.6c1.1-9.9,11.2-17.3,19.8-20L23.7,7.2   c-11,3.7-22.4,14.5-23.5,26.6C-1.5,46.8,7.9,58.4,19.1,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.3,7.2L61.2,19.3c8.6,2.8,18.7,10.1,19.8,20c0.6,7.5-3.5,14-9.7,18.6l6.6,6.4c11.2-5.9,20.6-17.5,18.9-30.5   C95.7,21.7,84.3,10.8,73.3,7.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.6,65.6 6.3,77.5 90.7,77.5 78.4,65.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M319.4,13.2c-25.8,0-41.3,13.6-45.3,33.3c-3.9,19.7,6.2,33.3,32,33.3c25.8,0,41.3-13.6,45.3-33.3   C355.4,26.7,345.2,13.2,319.4,13.2z M320.8,46.5c-3,14.6-6.8,16.8-11.3,16.8c-4.6,0-7.6-2.2-4.6-16.8c2.8-14.3,6.6-16.8,11.3-16.8   C320.9,29.6,323.5,32.2,320.8,46.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKroneBlue);
export default __webpack_public_path__ + "static/media/krone-blue.dfa7adf94348bac19a6ecd86f9b54489.svg";
export { ForwardRef as ReactComponent };